import { render } from "./ExportarRegistros.vue?vue&type=template&id=7aeaa548&scoped=true"
import script from "./ExportarRegistros.vue?vue&type=script&lang=js"
export * from "./ExportarRegistros.vue?vue&type=script&lang=js"

import "./ExportarRegistros.vue?vue&type=style&index=0&id=7aeaa548&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7aeaa548"]])

export default __exports__